import { Stack, Title, Text } from '@mantine/core'
import cls from 'classnames'
import styles from './index.module.scss'

type Props = {
  className?: string
}

const Jumbotron = ({ className }: Props) => {
  return (
    <Stack className={cls(styles.jumbotron, className)} pt={192} spacing={0} align="center">
      <Title weight={900} className="sm:leading-[81px] leading-[48px] text-[32px] sm:text-[56px] mb-[8px] sm:mb-[12px]">
        如何在真实场景使用浩客
      </Title>
      <Text className="sm:leading-[25px] sm:text-[18px] leading-[24px] text-[16px]">需要灵感？不妨看看以下模板🧐</Text>
    </Stack>
  )
}

export default Jumbotron
